import { Box, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import SettingsIcon from '@mui/icons-material/Settings';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { TTagsSituacao } from "../../types/ITagSituacao";

export default function TagsSituacao({
    situacao,
    filled = false
}: TagsSituacaoProps) {

    const [stylesType, setStyleType] = useState({
        color: "#ccc",
        icon: QuestionMarkIcon
    })

    useEffect(() => {
        switch (situacao) {
            case "Em execução":
                setStyleType({
                    color: "#FF9900",
                    icon: SettingsIcon
                })
                break;
            case "Finalizado":
                setStyleType({
                    color: "#005540",
                    icon: CheckCircleIcon
                })
                break;
            case "Suspenso":
                setStyleType({
                    color: "#D60000",
                    icon: CancelIcon
                })
                break;
        }
    }, [situacao])

    return (
        <Box
            px={0.8}
            py={0.2}
            gap={0.3}
            display="flex"
            justifyContent="center"
            alignItems="center"
            border={`1px solid ${stylesType.color}`}
            bgcolor={filled ? stylesType.color : "transparent"}
            borderRadius={2}
            maxWidth={180}
        >
            <stylesType.icon fontSize="small" sx={{ color: filled ? "white" : stylesType.color }} />
            <Typography color={filled ? "white" : stylesType.color} fontSize={13}>{situacao}</Typography>
        </Box>
    )
}

interface TagsSituacaoProps {
    situacao: TTagsSituacao,
    filled?: boolean
}

